@if (opened()) {
  <!-- Back-drop -->
  <div class="dialog-backdrop" (click)="close()"></div>

  <!-- Dialog -->
  <section
    class="dialog"
    [class.dialog--center]="modalCenter()"
    role="dialog"
    aria-modal="true"
    (click)="$event.stopPropagation()">

    <header class="dialog__header">
      <button
        type="button"
        class="dialog__close"
        aria-label="close"
        (click)="close()">
        <span class="dialog__close-icon" aria-hidden="true"></span>
      </button>
    </header>

    <div class="dialog__body">
      <ng-content></ng-content>
    </div>
  </section>
}
